//#region ImportsSection
import { useState } from "react";
import swal from "sweetalert";
import { GetSelectedLanguage } from "../../helper/Method";
import { GetLanguageString } from "../../helper/Components";
import { t } from "i18next";
import {
  FormGroup,
  Form,
  Label,
  Input,
  Button,
  ModalBody,
  ModalFooter,
  FormFeedback,
  Modal,
  ModalHeader,
} from "reactstrap";
import { isUrdu, LoadingSpinner } from "../../../constants/const";
import Draggable from "react-draggable";
import ApiSyllabusBook from "./ApiSetupBook";
//#endregion ImportsSection

const EditSyllabusBook = ({
  selectedBook,
  setEditModal,
  refresh,
  setRefresh,
}) => {
  //#region StateSection
  const [formData, setFormData] = useState(selectedBook);
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  //#endregion StateSection

  //#region functionSection

  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  const validate = () => {
    let temp = {};
    temp.bookName = formData.bookName ? (
      ""
    ) : (
      <GetLanguageString props="common_field_required_error" />
    );

    setErrors({
      ...temp,
    });
    return Object.values(temp).every((x) => x === "");
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      bookName: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      setButtonDisable(true);
      ApiSyllabusBook()
        .EditSetupBook(formData)
        .then((res) => {
          console.log(res);
          if (res.data.statusCode === "200") {
            swal({
              title: t("edited_syllabus_books"),
              className: GetSelectedLanguage() === "en" ? "" : "ur",
              icon: "success",
              buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
            });
          } else {
            swal({
              title: t("common_error_message"),
              className: GetSelectedLanguage() === "en" ? "" : "ur",
              icon: "error",
              buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
            });
          }

          setRefresh(!refresh);
          setEditModal(false);
          setLoading(false);
          setButtonDisable(false);
        })
        .catch((err) => {
          swal({
            title: err,
            icon: "error",
            buttons: "OK",
          });
          setLoading(false);
          setButtonDisable(false);
        });
    }
  };
  //#endregion functionSection

  return (
    <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
      <Modal isOpen={true} className="inmodal" autoFocus={false}>
        <ModalHeader className="modal-title" tag="h4">
          <GetLanguageString props="edit_syllabus_books" />
        </ModalHeader>
        {!loading ? (
          <Form onSubmit={handleSubmit}>
            <ModalBody>
              <FormGroup>
                <Label>
                  <GetLanguageString props="syllabus_books_name" />
                </Label>
                <Input
                  autoFocus
                  type="text"
                  name="bookName"
                  className={
                    isUrdu(formData.bookName) ? "no-drag ur" : "no-drag"
                  }
                  value={formData.bookName}
                  onChange={handleInputChange}
                  {...(errors?.bookName && { invalid: true })}
                />
                {errors?.bookName && (
                  <FormFeedback>
                    <h4>{errors?.bookName}</h4>
                  </FormFeedback>
                )}
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="white" onClick={() => setEditModal(false)}>
                <GetLanguageString props="common_cancel" />
              </Button>
              <Button color="primary" type="submit" disabled={buttonDisable}>
                <GetLanguageString props="common_save" />
              </Button>{" "}
            </ModalFooter>
          </Form>
        ) : (
          LoadingSpinner()
        )}
      </Modal>
    </Draggable>
  );
};

export default EditSyllabusBook;
